import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { isLoggedIn, filtersToQueryParams } from "utils/misc";

export default function useBlacklistedUsers() {
  const { user, token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlacklistedUsers = useCallback(async () => {
    if (!isLoggedIn(user)) return;
    setLoading(true);

    const { response, data } = await API.fetchBlockedUsers(token);

    if (response.ok) {
      setResult(data);
    }

    setLoading(false);
  }, [token]);

  useEffect(() => {
    fetchBlacklistedUsers();
  }, [token]);

  return {
    loading,
    refresh: fetchBlacklistedUsers,
    users: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
